import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import knowledgeConfigAgentIdentityQuery from '@atlassian/jira-relay/src/__generated__/knowledgeConfig_agentIdentityQuery.graphql';

export const helpCenterSettingsAgentStudioKnowledgeAppEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-help-center-setting-agent-studio-knowledge-config-app" */ './index'
			),
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
		queries: {
			page: {
				parameters: knowledgeConfigAgentIdentityQuery,
				variables: {
					helpCenterAri: `ari:cloud:help::help-center/${tenantContext.activationId}/${context.match.params.helpCenterId}`,
				},
			},
		},
	}),
});
